import { root, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManifest } from './manifest';

setupServiceInfo(__serviceInfo__);
// @ts-ignore
root.ServiceRegistry['elc-service-smartgift'] = ServiceManifest;
